import { Button } from "@mui/material";
import * as React from "react";
import { useKey } from "react-use";
import { useSaveData } from "../hooks/useSaveData";
import { canExecute } from "../lib/canExecute";
import { SaveButtonProps } from "../utils/interfaces/core/SaveBtn";

const SaveButton: React.FC<SaveButtonProps> = ({
  onSave,
  children,
  ...props
}) => {
  const saveData = useSaveData();

  const saveHandler = async () => {
    try {
      const data = await saveData();

      await onSave(data);
    } catch (error) {
      console.error(error);
    }
  };

  useKey("s", (event) => {
    if (canExecute(event)) saveHandler();
  });

  return (
    <Button
      size="small"
      variant="contained"
      color="secondary"
      {...props}
      onClick={saveHandler}
    >
      {children ?? "Sauvegarder"}
    </Button>
  );
};

export default SaveButton;
